import * as ContextMenuPrimitive from '@radix-ui/react-context-menu';
import { styled } from '../../../stitches.config';

const contentStyles = {
  zIndex: 100,
  backgroundColor: 'white',
  borderRadius: '$medium',
  paddingBottom: '$3',
  overflow: 'hidden',
  boxShadow: '$small',
};
const StyledContent = styled(ContextMenuPrimitive.Content, {
  minWidth: 220,
  ...contentStyles,
});
const StyledSubContent = styled(ContextMenuPrimitive.SubContent, {
  ...contentStyles,
});

const itemStyles = {
  'all': 'unset',
  'fontSize': '$1',
  'lineHeight': 1,
  'color': '$slate11',
  'borderRadius': '$small',
  'display': 'flex',
  'alignItems': 'center',
  'padding': '.35rem .7rem',
  'margin': '0 $2',
  'position': 'relative',
  'userSelect': 'none',
  'cursor': 'pointer',

  '&[data-disabled]': {
    color: '$slate9',
    pointerEvents: 'none',
  },
  '&:hover': {
    backgroundColor: '$purple3',
    color: '$purple9',
  },
  '&:focus': {
    backgroundColor: '$purple3',
    color: '$purple9',
  },
};

const StyledItem = styled(ContextMenuPrimitive.Item, { ...itemStyles });
const StyledCheckboxItem = styled(ContextMenuPrimitive.CheckboxItem, {
  ...itemStyles,
});
const StyledRadioItem = styled(ContextMenuPrimitive.RadioItem, {
  ...itemStyles,
});
const StyledSubTrigger = styled(ContextMenuPrimitive.SubTrigger, {
  '&[data-state="open"]': {
    backgroundColor: '$purple3',
    color: '$purple9',
  },
  ...itemStyles,
});

const StyledLabel = styled(ContextMenuPrimitive.Label, {
  'fontSize': '$1',
  'padding': '.25rem .7rem',
  'marginBottom': '$2',
  'color': '$slate10',
  'textTransform': 'uppercase',
  'backgroundColor': '$slate3',
  '&:not(:first-child)': {
    marginTop: '$4',
  },
});

const StyledSeparator = styled(ContextMenuPrimitive.Separator, {
  height: 1,
  backgroundColor: '$slate6',
  margin: 5,
});

const StyledItemIndicator = styled(ContextMenuPrimitive.ItemIndicator, {
  position: 'absolute',
  left: 0,
  width: 25,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ContextMenuPortal = ContextMenuPrimitive.Portal;
export const ContextMenu = ContextMenuPrimitive.Root;
export const ContextMenuTrigger = ContextMenuPrimitive.Trigger;
export const ContextMenuContent = StyledContent;
export const ContextMenuItem = StyledItem;
export const ContextMenuCheckboxItem = StyledCheckboxItem;
export const ContextMenuRadioGroup = ContextMenuPrimitive.RadioGroup;
export const ContextMenuRadioItem = StyledRadioItem;
export const ContextMenuItemIndicator = StyledItemIndicator;
export const ContextMenuLabel = StyledLabel;
export const ContextMenuSeparator = StyledSeparator;
export const ContextMenuSub = ContextMenuPrimitive.Sub;
export const ContextMenuSubContent = StyledSubContent;
export const ContextMenuSubTrigger = StyledSubTrigger;
